import { NxObject, NxObjectType } from '@warehouse/object-browser/core';
import { JobReference } from './job-reference';

/**
 * `object`: `undefined` while the Inventory lookup is pending, `null` when the Inventory does not know the object.
 * `copies`: every file with the same content (the object's own eTag for a uuid-keyed job), `undefined` until known.
 */
export type ResolvedJobReference =
	| { kind: 'object'; nxObjectUuid: string; object: NxObject | null | undefined; copies: NxObject[] | undefined }
	| { kind: 'content'; eTag: string; copies: NxObject[] | undefined }
	| { kind: 'unknown' };

export type ObjectsByUuid = Record<string, NxObject | null>;
export type CopiesByETag = Record<string, NxObject[]>;

/** One job's reference with what the Inventory said about it so far: its object, or its content's copies. */
export function resolveJobReference(
	reference: JobReference,
	{ object, copies }: { object: NxObject | null | undefined; copies: NxObject[] | undefined },
): ResolvedJobReference {
	switch (reference.kind) {
		case 'object':
			return { ...reference, object, copies };
		case 'content':
			return { ...reference, copies };
		default:
			return reference;
	}
}

/** The distinct buckets the copies live in; an empty array while unresolved. */
export function bucketsOf(copies: NxObject[] | undefined): string[] {
	return [...new Set((copies ?? []).map((copy) => copy.bucketId as string))];
}

export function isFile(object: NxObject | null | undefined): boolean {
	return object?.itemType === NxObjectType.File;
}
